// extracted by mini-css-extract-plugin
export default {"overflow-container":"_9KRBqfoeC","overflowContainer":"_9KRBqfoeC"};